import createImmutableSelector from 'lib/immutable/selector'
import { IProtagonistas } from './../models'

// TODO: import Store type and add reducer type in Store interface
const getProtagonistas = (state: any): IProtagonistas => state.get('protagonistasReducer')

export const protagonistasSelector = createImmutableSelector(getProtagonistas, (protagonistas) => protagonistas)
